// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Translations 
import { withTranslation } from "react-i18next";
// SVG
import { errorSvg, successSvg } from "assets";
// Application
import { translate, convertException } from "vendor/application";

class OrderNotify extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { domain, type, error, onClick, t } = this.props;
    return (
      <div>

        <h2>{t(`${domain}.${type}.title`)}</h2>
        {
          type === "error" ?
            errorSvg() :
            successSvg()
        }
        <div>
          {
            type === "error" ? 
              <React.Fragment>
                <span>{t(`${domain}.${type}.description`)}</span>
                <span><strong>{translate(`backend_errors.${domain}.${convertException(error)}`, t)}</strong></span>
              </React.Fragment>
            :
              <React.Fragment>
                <span>{t(`${domain}.${type}.description_01`)}</span>
                <span>{t(`${domain}.${type}.description_02`)}</span>
              </React.Fragment>
          }
        </div>
        <div>
          <button onClick={(e) => onClick(e, type)} className="btn btn-green">{t(`${domain}.${type}.action_button`)}</button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state
  };
};

const connect_ = connect(
  mapStateToProps
)(OrderNotify);

export default withTranslation("notifications")(connect_);